
import { apiSlice } from "./apiSlice";
import { ENGLISHQUIZ_URL } from "../constants";

export const englishQuizApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ======================================================
    // English Quiz Management
    // ======================================================

    createEnglishQuiz: builder.mutation({
      query: (data) => ({
        url: ENGLISHQUIZ_URL,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["EnglishQuiz"],
    }),

    getEnglishQuizzes: builder.query({
      query: (params = {}) => ({
        url: ENGLISHQUIZ_URL,
        params,
      }),
      providesTags: ["EnglishQuiz"],
      keepUnusedDataFor: 5,
    }),

    getEnglishQuizzesBySubject: builder.query({
      query: (subjectId) => ({
        url: `${ENGLISHQUIZ_URL}/subject/${subjectId}`,
      }),
      providesTags: (result, error, subjectId) => [
        { type: "EnglishQuiz", id: `SUBJECT-${subjectId}` },
      ],
      keepUnusedDataFor: 5,
    }),

    getEnglishQuizById: builder.query({
      query: (quizId) => ({
        url: `${ENGLISHQUIZ_URL}/${quizId}`,
      }),
      providesTags: (result, error, quizId) => [
        { type: "EnglishQuiz", id: quizId },
      ],
      keepUnusedDataFor: 5,
    }),

    updateEnglishQuiz: builder.mutation({
      query: ({ quizId, ...data }) => ({
        url: `${ENGLISHQUIZ_URL}/${quizId}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { quizId }) => [
        "EnglishQuiz",
        { type: "EnglishQuiz", id: quizId },
      ],
    }),

    deleteEnglishQuiz: builder.mutation({
      query: (quizId) => ({
        url: `${ENGLISHQUIZ_URL}/${quizId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, quizId) => [
        "EnglishQuiz",
        { type: "EnglishQuiz", id: quizId },
      ],
    }),

    // ======================================================
    // Publish / Status Management
    // ======================================================

    publishEnglishQuiz: builder.mutation({
      query: (quizId) => ({
        url: `${ENGLISHQUIZ_URL}/${quizId}/publish`,
        method: "PATCH",
      }),
      invalidatesTags: (result, error, quizId) => [
        "EnglishQuiz",
        { type: "EnglishQuiz", id: quizId },
      ],
    }),

    unpublishEnglishQuiz: builder.mutation({
      query: (quizId) => ({
        url: `${ENGLISHQUIZ_URL}/${quizId}/unpublish`,
        method: "PATCH",
      }),
      invalidatesTags: (result, error, quizId) => [
        "EnglishQuiz",
        { type: "EnglishQuiz", id: quizId },
      ],
    }),

    archiveEnglishQuiz: builder.mutation({
      query: (quizId) => ({
        url: `${ENGLISHQUIZ_URL}/${quizId}/archive`,
        method: "PATCH",
      }),
      invalidatesTags: (result, error, quizId) => [
        "EnglishQuiz",
        { type: "EnglishQuiz", id: quizId },
      ],
    }),

    activateEnglishQuiz: builder.mutation({
      query: (quizId) => ({
        url: `${ENGLISHQUIZ_URL}/${quizId}/activate`,
        method: "PATCH",
      }),
      invalidatesTags: (result, error, quizId) => [
        "EnglishQuiz",
        { type: "EnglishQuiz", id: quizId },
      ],
    }),

    // ======================================================
    // Statistics
    // ======================================================

    getEnglishQuizStatistics: builder.query({
      query: (quizId) => ({
        url: `${ENGLISHQUIZ_URL}/${quizId}/statistics`,
      }),
      providesTags: (result, error, quizId) => [
        { type: "EnglishQuiz", id: `STATISTICS-${quizId}` },
      ],
      keepUnusedDataFor: 5,
    }),
    getStudentEnglishQuizzes: builder.query({
  query: () => ({
    url: `${ENGLISHQUIZ_URL}/student`,
  }),
}),

    recalculateEnglishQuiz: builder.mutation({
      query: (quizId) => ({
        url: `${ENGLISHQUIZ_URL}/${quizId}/recalculate`,
        method: "POST",
      }),
      invalidatesTags: (result, error, quizId) => [
        "EnglishQuiz",
        { type: "EnglishQuiz", id: quizId },
        { type: "EnglishQuiz", id: `STATISTICS-${quizId}` },
      ],
    }),
  }),
});

export const {
  // ======================================================
  // English Quiz Management
  // ======================================================

  useCreateEnglishQuizMutation,
  useGetEnglishQuizzesQuery,
  useGetStudentEnglishQuizzesQuery,
  useGetEnglishQuizzesBySubjectQuery,
  useGetEnglishQuizByIdQuery,
  useUpdateEnglishQuizMutation,
  useDeleteEnglishQuizMutation,

  // ======================================================
  // Publish / Status
  // ======================================================

  usePublishEnglishQuizMutation,
  useUnpublishEnglishQuizMutation,
  useArchiveEnglishQuizMutation,
  useActivateEnglishQuizMutation,

  // ======================================================
  // Statistics
  // ======================================================

  useGetEnglishQuizStatisticsQuery,
  useRecalculateEnglishQuizMutation,
} = englishQuizApiSlice;

